module.exports = __webpack_public_path__ + "static/media/social-github.d1099e27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-github.svg
// module id = 137
// module chunks = 0